import styled, { css } from "styled-components";
import Input from "components/Input";

export const CustomColorContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 26.5rem;
  height: 27.8125rem;
  margin-top: 1rem;
  flex-direction: column;
  background: var(--black-200);
  align-items: center;
  justify-content: center;
  gap: 2rem;

  h2 {
    font-weight: 600;
    font-size: 2rem;
  }

  label {
    display: flex;
    flex-direction: column;
    gap: 1.4rem;
    align-items: center;
    font-size: 1.2rem;

    input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      width: 40px;
      height: 40px;
      background-color: transparent;
      border: none;
      cursor: pointer;

      ::-webkit-color-swatch {
        border-radius: 50%;
      }

      ::-moz-color-swatch {
        border-radius: 50%;
      }
    }
  }
`;

export const CurrentColor = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;

  div {
    background: var(--primary);
    width: 30px;
    height: 30px;
    border-radius: 50%;
  }
`;

export const ProfileContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
`;

export const ProfileContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  place-items: center;
  place-content: center;
  column-gap: 5rem;
  margin: auto;

  .profile-menu-wrapper {
    @media screen and (max-width: 1400px) {
      width: 20rem;
    }
  }

  h1 {
    font-size: 1.7rem;
  }

  @media screen and (max-width: 1400px) {
    column-gap: 1rem;
    padding: 2rem;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1rem 0;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  h2 {
    font-size: 2rem;
  }

  svg {
    width: 3.3125rem;
    height: 3.3125rem;

    path {
      stroke: var(--primary);
    }
  }
`;

export const ProfileContent = styled.div`
  
  width: 17.3125rem;
  font-weight: 500;

  h1 {
    font-size: 2rem;
    line-height: 2rem;
    border-bottom: 1px solid var(--black-400);
    padding-bottom: 1.625rem;
  }
`;

export const ProfileActiveButton = styled.button<{ active: boolean }>`
  background: var(--black-300);
  color: var(--white);
  font-family: DM Sans;
  font-style: normal;
  font-weight: 500;
  color: var(--white);
  position: relative;
  width: 100%;
  height: 3rem;
  margin-top: 1rem;

  ${({ active }) =>
    active &&
    css`
      border-left: 2px solid var(--primary);
    `}
`;

export const ViewPasswordButton = styled.button`
  width: 1.5625rem;
  background: none;
  height: 5px;
  margin-top: -2.8125rem !important;
  margin-left: auto;
  margin-right: 20px;
  margin-bottom: 2.5rem;
`;

export const PasswordForm = styled.form`
  width: 26.5rem;
  height: 27.8125rem;
  background: var(--black-200);
  border-radius: 0.25rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div {
    margin-bottom: 1rem;
  }

  button {
    margin-top: 3rem;
  }
`;

export const DocumentContainer = styled.div`
  display: grid;
  width: 22rem;
  grid-template-columns: 1.32fr 1fr;
  column-gap: 1rem;
  margin-bottom: 0;
  div {
    width: 100%;
    input {
      width: 100%;
    }
  }
`;

export const DataForm = styled.form`
  width: 26.5rem;
  min-height: 26rem;
  background: var(--black-200);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2.3rem 2.5rem;

  div {
    margin-bottom: 1rem;
  }

  button {
    margin-top: 1rem;
    width: 100%;
  }
`;

export const DataInput = styled(Input)`
  width: 100%;
`;
